import { Chip, styled } from '@mui/material';

export const StyledFocusChip = styled(Chip)({
  height: 'auto',
  maxWidth: '100%',
  padding: '4px 12px',
  gap: '4px',
  borderRadius: '12px',
  '& .MuiChip-icon': {
    margin: 0,
    width: 16,
    height: 16,
    flexShrink: 0,
  },
  '& .MuiChip-label': {
    padding: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  '& .MuiChip-deleteIcon': {
    margin: 0,
    width: 16,
    height: 16,
    flexShrink: 0,
  },
});
